var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "export-btn-box" }, [
    _vm.exportAsLinks.length > 0
      ? _c(
          "div",
          {
            staticClass: "export-btn",
            class: { disabled: _vm.disabled },
            on: { click: _vm.openDropdown },
          },
          [
            _vm._v("\n    " + _vm._s(_vm._f("trans")("Export As")) + "\n    "),
            !_vm.dropdownActive
              ? _c("i", { staticClass: "far fa-chevron-down" })
              : _vm._e(),
            _vm._v(" "),
            _vm.dropdownActive
              ? _c("i", { staticClass: "far fa-chevron-up" })
              : _vm._e(),
            _vm._v(" "),
            _vm.dropdownActive &&
            _vm.currentJob.state !== "failed" &&
            _vm.currentJob.state !== "processing" &&
            _vm.currentJob.state !== "not_found"
              ? _c(
                  "div",
                  { attrs: { id: "export-dropdown" } },
                  [
                    _vm._l(_vm.exportAsLinks, function (item) {
                      return _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-item text-uppercase",
                            on: {
                              click: function ($event) {
                                return _vm.openExport(item.feature.operation)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm._f("trans")(item.extension)) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-divider" }),
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.openMore()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "far fa-ellipsis-h" }),
                        _vm._v(" more\n      "),
                      ]
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.exportAsLinks.length === 0
      ? _c(
          "div",
          {
            staticClass: "export-btn",
            class: { disabled: _vm.disabled },
            on: { click: _vm.openMore },
          },
          [_vm._v("\n    " + _vm._s(_vm._f("trans")("Export As")) + "\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }